import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrafficBadge } from "@/components/Atoms";
import { normSearch } from "@/lib/utils";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function InspectionsList() {
    const [items, setItems] = useState([]);
    const [q, setQ] = useState("");
    const [estado, setEstado] = useState("");
    useEffect(() => { (async () => setItems((await api.get("/inspections")).data))(); }, []);

    const filtered = items.filter(it => {
        if (estado && it.estado_salud !== estado) return false;
        if (!q) return true;
        const s = normSearch(q);
        return [it.client?.razon_social, it.sistema_revisado, it.inspection_id, it.order_number, it.technician_name, it.norma_iso]
            .some(v => normSearch(v).includes(s));
    });

    return (
        <div className="max-w-7xl mx-auto p-4 md:p-8" data-testid="inspections-list-page">
            <div className="flex items-end justify-between mb-8 border-b border-zinc-200 pb-6">
                <div>
                    <div className="overline mb-2">Registro</div>
                    <h1 className="font-display text-4xl font-black tracking-tighter">Inspecciones</h1>
                </div>
            </div>
            <div className="grid md:grid-cols-[1fr_auto] gap-4 mb-6">
                <div className="relative">
                    <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
                    <input value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar por cliente, sistema, técnico, ID, orden…" className="input-atia pl-10" data-testid="filter-search" />
                </div>
                <div className="flex gap-0 border border-zinc-200">
                    {["", "verde", "amarillo", "rojo", "sin_evaluar"].map(v => (
                        <button key={v || "todos"} onClick={() => setEstado(v)} className={`px-3 py-2 text-[11px] font-bold uppercase tracking-wider border-r border-zinc-200 last:border-r-0 transition-colors ${estado === v ? "bg-zinc-900 text-white" : "bg-white hover:bg-zinc-50"}`} data-testid={`filter-estado-${v || "todos"}`}>
                            {v ? v.replace("_", " ") : "Todos"}
                        </button>
                    ))}
                </div>
            </div>
            <div className="border border-zinc-200 overflow-x-auto">
                <table className="atia-table" data-testid="inspections-table">
                    <thead><tr><th>ID</th><th>Orden</th><th>Cliente</th><th>Sistema</th><th>Técnico</th><th>Norma</th><th>Estado</th><th>Hallazgos</th></tr></thead>
                    <tbody>
                        {filtered.length === 0 && <tr><td colSpan={8} className="text-center py-12 text-zinc-500">Sin resultados.</td></tr>}
                        {filtered.map(it => (
                            <tr key={it.inspection_id} className="row-link" onClick={() => (window.location.href = `/inspections/${it.inspection_id}`)} data-testid={`row-${it.inspection_id}`}>
                                <td className="font-mono text-xs">{it.inspection_id}</td>
                                <td className="font-mono text-xs">{it.order_number}</td>
                                <td className="font-semibold">{it.client?.razon_social || "—"}</td>
                                <td className="text-zinc-700 text-xs">{it.sistema_revisado}</td>
                                <td className="text-zinc-700">{it.technician_name}</td>
                                <td className="text-zinc-500 text-[11px]">{it.norma_iso}</td>
                                <td><TrafficBadge value={it.estado_salud} /></td>
                                <td className="font-mono text-xs">{it.hallazgos_count ?? 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
